import { render, staticRenderFns } from "./send-notice-list.vue?vue&type=template&id=4532edc8&scoped=true&"
import script from "./send-notice-list.vue?vue&type=script&lang=js&"
export * from "./send-notice-list.vue?vue&type=script&lang=js&"
import style0 from "./send-notice-list.vue?vue&type=style&index=0&id=4532edc8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532edc8",
  null
  
)

export default component.exports